import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { User } from './types'

export const submitCreateUser = createEvent<User>()

export const closeModal = createEvent()

export const createUser = fx<User, void>({
  method: 'POST',
  url: '/user',
})

sample({
  clock: submitCreateUser,
  fn: (user) => {
    return {
      url: `/user`,
      body: { ...user },
    }
  },
  target: createUser,
})

export const $isSuccessCreate = restore(
  createUser.doneData.map(() => true),
  false,
).reset(closeModal)
